module.exports = __webpack_public_path__ + "img/14.a08e1bad.jpg";